module.exports = __webpack_public_path__ + "static/media/m_eyeshape_hooded_darkbrown.71c930dd.png";